import { render, staticRenderFns } from "./comments-item.vue?vue&type=template&id=19bcd705"
import script from "./comments-item.vue?vue&type=script&lang=js"
export * from "./comments-item.vue?vue&type=script&lang=js"
import style0 from "./comments-item.vue?vue&type=style&index=0&id=19bcd705&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports